/// <reference path="../types.d.ts" /

export const defaultEula = {
  userId: -1,
  acceptedDate: null,
  organizationId: -1,
  eulaId: null,
  text: ''
};
export const eula: CMxCommonApp.EulaState = {
  eula: defaultEula,
  isCancelled: false
};
